import { StarbucksOrderType } from './starbucks_order_type.js';

export function name(orderType: StarbucksOrderType): string {
  switch (orderType) {
    case StarbucksOrderType.InStore:
      return 'In-Store';
    case StarbucksOrderType.DriveThru:
      return 'Drive-Thru';
    case StarbucksOrderType.Curbside:
      return 'Curbside';
    case StarbucksOrderType.Outdoor:
      return 'Outdoor';
  }
}
